import { render } from "./CommonFullscreen.vue?vue&type=template&id=2c791c8c&scoped=true"
import script from "./CommonFullscreen.vue?vue&type=script&lang=js"
export * from "./CommonFullscreen.vue?vue&type=script&lang=js"

import "./CommonFullscreen.vue?vue&type=style&index=0&id=2c791c8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c791c8c"]])

export default __exports__